import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-end my-4" }
const _hoisted_2 = { class: "h-full overflow-y-auto" }
const _hoisted_3 = { class: "w-full text-sm text-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", { class: "text-white bg-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3" }, "Brand"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3" })
  ])
], -1)
const _hoisted_5 = { class: "px-2 py-3" }
const _hoisted_6 = { class: "flex items-center justify-end px-2 py-3 gap-x-2" }
const _hoisted_7 = { class: "flex flex-col w-96 gap-y-2" }

import Modal from '@/components/Modal/Modal.vue';
import TextField from '@/components/Inputs/TextField.vue';
import { computed, inject, onMounted, Ref, ref } from 'vue';
import { cloneDeep } from 'lodash';
import Button from '@/components/UI/Button.vue';
import { useBrandStore } from '@/store/brands';
import { Brand } from '@/typings/brand';
import { PromptModal } from '@/typings/modal';
import { apiBrands } from '@/api/brand';
import SearchDropdown from '@/components/Inputs/SearchDropdown.vue';
import { useFactionsStore } from '@/store/factions';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const promptModal = inject('promptModal') as Ref<PromptModal>;

const creationModalVisible = ref(false);
const newBrand = ref();

const factions = computed(() => {
  return useFactionsStore()
    .factions.map((f) => ({
      value: f.Uuid,
      text: f.Name,
    }))
    .sort((f1, f2) => (f1.text > f2.text ? 1 : -1));
});

const brandStore = useBrandStore();

function openCreate() {
  newBrand.value = {
    Name: '',
  };
  creationModalVisible.value = true;
}

function editBrand(editingBrand: Brand) {
  newBrand.value = cloneDeep(editingBrand);
  creationModalVisible.value = true;
}

async function deleteBrand(deletingBrand: Brand) {
  const doDelete = await promptModal.value.show(
    'Remove Brand',
    'You are about to remove a brand. All historic usages of this brand will remain. Are you sure you want to remove it?'
  );
  if (doDelete) {
    await brandStore.deleteBrand(deletingBrand);
  }
}

async function downloadQrCode(brand: Brand) {
  const response = await apiBrands.downloadQrCode(brand);
  const type = response.headers['content-type'];
  const fileName = response.headers['content-disposition']
    .split('filename=')[1]
    .split(';')[0];
  const blob = new Blob([response.data], { type });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
}

async function saveModal() {
  if (newBrand.value.CompanyId) {
    await brandStore.editBrand(newBrand.value);
  } else {
    await brandStore.addBrand(newBrand.value);
  }
  creationModalVisible.value = false;
}

const modalHeader = computed(() =>
  newBrand.value?.CompanyId ? 'Edit a brand' : 'Set up a brand'
);

const router = useRouter();

function goToFaction(uuid: string) {
  router.push({
    name: 'Faction',
    params: { factionId: uuid },
  });
}

onMounted(async () => {
  brandStore.getBrands();
  await useFactionsStore().getFactions();
});

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Button, {
        label: "Add Brand",
        onClick: openCreate
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(brandStore).brands, (brand) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: brand.CompanyId,
              class: "border-t"
            }, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(brand.Name), 1),
              _createElementVNode("td", _hoisted_6, [
                (brand.LinkedFaction)
                  ? (_openBlock(), _createBlock(Button, {
                      key: 0,
                      class: "cursor-pointer",
                      onClick: ($event: any) => (goToFaction(brand.LinkedFaction)),
                      title: "Go To Faction"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_fa_icon, { icon: "link" })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(Button, {
                  class: "cursor-pointer",
                  onClick: ($event: any) => (downloadQrCode(brand)),
                  title: "Download QR Code"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fa_icon, { icon: "download" })
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(Button, {
                  class: "cursor-pointer",
                  onClick: ($event: any) => (editBrand(brand))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fa_icon, { icon: "pencil-alt" })
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(Button, {
                  class: "cursor-pointer",
                  onClick: ($event: any) => (deleteBrand(brand))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_fa_icon, { icon: "trash" })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    (newBrand.value && creationModalVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: _unref(modalHeader),
          onClose: _cache[3] || (_cache[3] = ($event: any) => (creationModalVisible.value = false))
        }, {
          footer: _withCtx(() => [
            _createVNode(Button, {
              label: "Save",
              onClick: saveModal
            }),
            _createVNode(Button, {
              label: "Cancel",
              type: "secondary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (creationModalVisible.value = false))
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(TextField, {
                modelValue: newBrand.value.Name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newBrand.value.Name) = $event)),
                title: "Name",
                "max-length": 36
              }, null, 8, ["modelValue"]),
              _createVNode(SearchDropdown, {
                title: "Faction",
                modelValue: newBrand.value.LinkedFaction,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newBrand.value.LinkedFaction) = $event)),
                items: _unref(factions)
              }, null, 8, ["modelValue", "items"])
            ])
          ]),
          _: 1
        }, 8, ["header"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})